namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class UserCreditPaymentOrderGrid extends Serenity.EntityGrid<UserCreditPaymentOrderRow, any> {
        protected getColumnsKey() { return UserCreditPaymentOrderColumns.columnsKey; }
        protected getDialogType() { return UserCreditPaymentOrderDialog; }
        protected getIdProperty() { return UserCreditPaymentOrderRow.idProperty; }
        protected getInsertPermission() { return UserCreditPaymentOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return UserCreditPaymentOrderRow.localTextPrefix; }
        protected getService() { return UserCreditPaymentOrderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                grid: this,
                service: UserCreditPaymentOrderService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}
